var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("SeaExport.Edit"),
            width: "1370px",
            "custom-class": "edit-dialog",
            top: "5vh",
            "close-on-click-modal": false
          },
          on: { close: _vm.handleClose }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "85px", "label-position": "left" } },
            [
              _c("div", { staticClass: "form-content-wrapper" }, [
                _c("div", { staticClass: "up" }, [
                  _c(
                    "fieldset",
                    [
                      _c("legend", [
                        _vm._v(_vm._s(_vm.$t("SeaExport.ConsignInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ConsignationCompany"))
                              )
                            ]
                          ),
                          _c("cargo-company-select", {
                            ref: "customerSelect",
                            staticClass: "shipper-selector",
                            attrs: {
                              no: "1",
                              "popper-class": "shipper-selector-popper",
                              "method-params": {
                                customer: true,
                                companyLob: "seaExport",
                                active: true
                              },
                              "check-credit": true,
                              job: _vm.form,
                              "default-value": _vm.form.customerId || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.customerIdChange2ContractHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.PortOfDischarge"))
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "2",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.dischargingPortCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.dischargingPortCode = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.PlaceOfDelivery"))
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            staticClass: "port-of-delivery-selector",
                            attrs: {
                              no: "3",
                              "popper-class":
                                "port-of-delivery-selector-popper",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.destinationPortCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.destinationPortCode = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.LocalService"),
                            "label-width": "85px"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { no: "4" },
                              model: {
                                value: _vm.form.warehousing,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "warehousing", $$v)
                                },
                                expression: "form.warehousing"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.WarehouseLoadingStorage")
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { no: "5" },
                              model: {
                                value: _vm.form.landTransportation,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "landTransportation", $$v)
                                },
                                expression: "form.landTransportation"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.DoorLoadingDelivery")
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { no: "6" },
                              model: {
                                value: _vm.form.selfDeliver,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "selfDeliver", $$v)
                                },
                                expression: "form.selfDeliver"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.NotResponsibleForTruckingAndLoading"
                                  )
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "fieldset",
                    [
                      _c("legend", [
                        _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.form.containerLoadType === "FCL" ||
                                _vm.form.containerLoadType === "BB",
                              expression:
                                "form.containerLoadType==='FCL'||form.containerLoadType==='BB'"
                            }
                          ],
                          staticClass: "custom",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("booking-sea-eq-data-grid", {
                            ref: "bookingSeaEqDataGrid",
                            attrs: {
                              value: _vm.seaEqList,
                              "container-load-type": _vm.form.containerLoadType,
                              "is-edit": _vm.isEdit,
                              job: _vm.form
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.containerLoadType === "BULK",
                              expression: "form.containerLoadType==='BULK'"
                            }
                          ],
                          staticClass: "custom",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("booking-bulk-data-grid", {
                            attrs: {
                              value: _vm.cargoBulkDetailList,
                              "job-uuid": _vm.form.uuid,
                              "is-edit": _vm.isEdit
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.containerLoadType === "SPA",
                              expression: "form.containerLoadType==='SPA'"
                            }
                          ],
                          staticClass: "custom",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("booking-special-data-grid", {
                            attrs: {
                              value: _vm.seaEqList,
                              "is-edit": _vm.isEdit,
                              job: _vm.form
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("SeaExport.QuantityConsignActual"),
                            "label-width": "100px"
                          }
                        },
                        [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              { staticStyle: { display: "flex", flex: "1" } },
                              [
                                _c("auto-number-input", {
                                  attrs: { no: "7", precision: 0, min: 0 },
                                  on: {
                                    change: function($event) {
                                      return _vm.jobContractQwcChange(1)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.quantityContract,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "quantityContract",
                                        $$v
                                      )
                                    },
                                    expression: "form.quantityContract"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { padding: "0 2px" } },
                                  [_vm._v("/")]
                                ),
                                _c("auto-number-input", {
                                  attrs: { no: "8", precision: 0, min: 0 },
                                  on: {
                                    change: function($event) {
                                      _vm.SEUtils.changeQWCRule(
                                        null,
                                        function() {
                                          _vm.form.quantityContract =
                                            _vm.form.quantityActual
                                        }
                                      )
                                      _vm.changeSynBillOfLadingQWC()
                                    }
                                  },
                                  model: {
                                    value: _vm.form.quantityActual,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "quantityActual", $$v)
                                    },
                                    expression: "form.quantityActual"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("span", { staticStyle: { width: "30px" } }, [
                              _vm._v("PCS")
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("SeaExport.WeightConsignActual"),
                            "label-width": "100px"
                          }
                        },
                        [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              { staticStyle: { display: "flex", flex: "1" } },
                              [
                                _c("auto-number-input", {
                                  attrs: { no: "9", precision: 3, min: 0 },
                                  on: {
                                    change: function($event) {
                                      return _vm.jobContractQwcChange(2)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.weightContract,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "weightContract", $$v)
                                    },
                                    expression: "form.weightContract"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { padding: "0 2px" } },
                                  [_vm._v("/")]
                                ),
                                _c("auto-number-input", {
                                  ref: "weightActual",
                                  attrs: { no: "10", precision: 3, min: 0 },
                                  on: {
                                    change: function($event) {
                                      _vm.SEUtils.changeQWCRule(
                                        null,
                                        function() {
                                          _vm.form.weightContract =
                                            _vm.form.weightActual
                                        }
                                      )
                                      _vm.calculateChargeWeight()
                                    }
                                  },
                                  model: {
                                    value: _vm.form.weightActual,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "weightActual", $$v)
                                    },
                                    expression: "form.weightActual"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("span", { staticStyle: { width: "30px" } }, [
                              _vm._v("KGS")
                            ])
                          ])
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("SeaExport.CubageConsignActual"),
                            "label-width": "100px"
                          }
                        },
                        [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c(
                              "div",
                              { staticStyle: { display: "flex", flex: "1" } },
                              [
                                _c("auto-number-input", {
                                  attrs: { no: "11", precision: 3, min: 0 },
                                  on: {
                                    change: function($event) {
                                      return _vm.jobContractQwcChange(3)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.cubageContract,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "cubageContract", $$v)
                                    },
                                    expression: "form.cubageContract"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { padding: "0 2px" } },
                                  [_vm._v("/")]
                                ),
                                _c("auto-number-input", {
                                  ref: "cubageActual",
                                  attrs: { no: "12", precision: 3, min: 0 },
                                  on: {
                                    change: function($event) {
                                      _vm.SEUtils.changeQWCRule(
                                        null,
                                        function() {
                                          _vm.form.cubageContract =
                                            _vm.form.cubageActual
                                          _vm.form.chargeWeight =
                                            _vm.form.cubageActual
                                        }
                                      )
                                      _vm.calculateChargeWeight()
                                    }
                                  },
                                  model: {
                                    value: _vm.form.cubageActual,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "cubageActual", $$v)
                                    },
                                    expression: "form.cubageActual"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("span", { staticStyle: { width: "30px" } }, [
                              _vm._v("CBM")
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "fieldset",
                    { staticStyle: { width: "min-content" } },
                    [
                      _c("legend", [
                        _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: {
                            label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                          }
                        },
                        [
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: { no: "13" },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                  _vm.form.cargoEnglishName,
                                  function(val) {
                                    _vm.form.cargoEnglishName = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoEnglishName", $$v)
                              },
                              expression: "form.cargoEnglishName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.Marks") }
                        },
                        [
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: { no: "14" },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Marks"),
                                  _vm.form.mark,
                                  function(val) {
                                    _vm.form.mark = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mark", $$v)
                              },
                              expression: "form.mark"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "custom" },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("SeaExport.HsCode")))
                              ]),
                              _c("br"),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isEdit,
                                      expression: "isEdit"
                                    }
                                  ],
                                  attrs: { no: "15", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.showHsCodeSearchDialog(
                                        _vm.$t("Message.SelectHsCode"),
                                        function(p) {
                                          return (_vm.form.hsCode = p.code)
                                        }
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Search")))]
                              )
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: { no: "16", type: "textarea", rows: 5 },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.HsCode"),
                                  _vm.form.hsCode,
                                  function(val) {
                                    _vm.form.hsCode = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.hsCode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "hsCode", $$v)
                              },
                              expression: "form.hsCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "custom" },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.ChineseDescriptionOfGoods"
                                    )
                                  )
                                )
                              ]),
                              _c("br")
                            ]
                          ),
                          _c("cargo-rich-textarea", {
                            staticStyle: { height: "110px" },
                            attrs: {
                              no: "17",
                              "auto-uppercase": false,
                              "auto-half-word": false
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                                  _vm.form.cargoChineseName,
                                  function(val) {
                                    _vm.form.cargoChineseName = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoChineseName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoChineseName", $$v)
                              },
                              expression: "form.cargoChineseName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "fieldset",
                    [
                      _c("legend", [
                        _vm._v(_vm._s(_vm.$t("SeaExport.OperationInfo")))
                      ]),
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-user-select", {
                              ref: "sales",
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "18",
                                "method-params": {
                                  officeId: _vm.salesOfficeCheck
                                    ? _vm.$store.getters.currentOfficeId
                                    : "",
                                  category: "role",
                                  shape: "sales"
                                },
                                "default-value": _vm.form.sales || "",
                                "static-options": _vm.salesList,
                                placeholder: _vm.salesPrompt
                              },
                              on: {
                                change: function(p) {
                                  _vm.form.sales = p.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: { no: "19", disabled: true },
                                model: {
                                  value: _vm.form.provisioned,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "provisioned", $$v)
                                  },
                                  expression: "form.provisioned"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("SeaExport.Accrued")) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.OperationDepartment"))
                              )
                            ]
                          ),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "20",
                              "office-id": Number(_vm.form.opOffice),
                              "department-id": Number(_vm.form.opDepartment)
                            },
                            on: {
                              change: function(p) {
                                _vm.form.opDepartment = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Operation") } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "21",
                              "method-params": {
                                officeId: _vm.form.opOffice,
                                category: "role",
                                shape: "op"
                              },
                              "default-value": _vm.form.op || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.form.op = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Documents") } },
                        [
                          _c("cargo-user-select", {
                            ref: "dc",
                            attrs: {
                              no: "22",
                              "method-params": {
                                officeId: _vm.form.opOffice,
                                category: "role",
                                shape: "doc"
                              },
                              "default-value": _vm.form.dc || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.form.dc = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "down" }, [
                  _c("fieldset", [
                    _c("legend", [
                      _vm._v(_vm._s(_vm.$t("SeaExport.CustomerDeliveryInfo")))
                    ]),
                    _c("div", { staticClass: "custom-delivery-info-wrapper" }, [
                      _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { label: _vm.$t("SeaExport.Shipper") }
                            },
                            [
                              _c("cargo-company-select", {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "173px"
                                },
                                attrs: {
                                  no: "23",
                                  "method-params": {
                                    shipper: true,
                                    active: true
                                  },
                                  "default-value": _vm.form.shipperId || ""
                                },
                                on: {
                                  change: function(data) {
                                    _vm.shipperChange(data)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "24", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.billAddressDialog.visible = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._l(7, function(i) {
                            return _c(
                              "el-form-item",
                              { key: i, staticClass: "label-none custom" },
                              [
                                _c("cargo-input", {
                                  ref: "shipperLine" + i,
                                  refInFor: true,
                                  attrs: { no: "25", "auto-uppercase": true },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.form,
                                        "shipperLine" + i,
                                        i + 1 > 6
                                          ? null
                                          : "shipperLine" + (i + 1),
                                        45
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      _vm.showAdvanceTextDialog(
                                        _vm.$t("SeaExport.Shipper"),
                                        _vm.mergeShipperLine(),
                                        _vm.splitShipperLine,
                                        true
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form["shipperLine" + i],
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipperLine" + i, $$v)
                                    },
                                    expression: "form['shipperLine'+i]"
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { label: _vm.$t("SeaExport.Consignee") }
                            },
                            [
                              _c("cargo-company-select", {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "173px"
                                },
                                attrs: {
                                  no: "26",
                                  "method-params": {
                                    consignee: true,
                                    active: true
                                  },
                                  "default-value": _vm.form.consigneeId || ""
                                },
                                on: {
                                  change: function(data) {
                                    _vm.consigneeChange(data)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "27", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.billAddressDialog.visible = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._l(7, function(i) {
                            return _c(
                              "el-form-item",
                              { key: i, staticClass: "label-none custom" },
                              [
                                _c("cargo-input", {
                                  ref: "consigneeLine" + i,
                                  refInFor: true,
                                  attrs: { no: "28", "auto-uppercase": true },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.form,
                                        "consigneeLine" + i,
                                        i + 1 > 6
                                          ? null
                                          : "consigneeLine" + (i + 1),
                                        45
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      _vm.showAdvanceTextDialog(
                                        _vm.$t("SeaExport.Consignee"),
                                        _vm.mergeConsigneeLine(),
                                        _vm.splitConsigneeLine,
                                        true
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form["consigneeLine" + i],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "consigneeLine" + i,
                                        $$v
                                      )
                                    },
                                    expression: "form['consigneeLine'+i]"
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      ),
                      _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { label: _vm.$t("SeaExport.NotifyParty") }
                            },
                            [
                              _c("cargo-company-select", {
                                staticStyle: {
                                  display: "inline-block",
                                  width: "173px"
                                },
                                attrs: {
                                  no: "29",
                                  "method-params": {
                                    notify: true,
                                    active: true
                                  },
                                  "default-value": _vm.form.notifyId || ""
                                },
                                on: {
                                  change: function(data) {
                                    _vm.notifyChange(data)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { no: "30", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.billAddressDialog.visible = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._l(7, function(i) {
                            return _c(
                              "el-form-item",
                              { key: i, staticClass: "label-none custom" },
                              [
                                _c("cargo-input", {
                                  ref: "notifyLine" + i,
                                  refInFor: true,
                                  attrs: { no: "31", "auto-uppercase": true },
                                  on: {
                                    change: function() {
                                      return _vm.wrapAddr(
                                        _vm.form,
                                        "notifyLine" + i,
                                        i + 1 > 6
                                          ? null
                                          : "notifyLine" + (i + 1),
                                        45
                                      )
                                    }
                                  },
                                  nativeOn: {
                                    dblclick: function($event) {
                                      _vm.showAdvanceTextDialog(
                                        _vm.$t("SeaExport.NotifyParty"),
                                        _vm.mergeNotifyLine(),
                                        _vm.splitNotifyLine,
                                        true
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form["notifyLine" + i],
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "notifyLine" + i, $$v)
                                    },
                                    expression: "form['notifyLine'+i]"
                                  }
                                })
                              ],
                              1
                            )
                          })
                        ],
                        2
                      ),
                      _c(
                        "div",
                        [
                          _c("el-form-item", {
                            attrs: {
                              label: _vm.$t("SeaExport.SecondNotifyParty")
                            }
                          }),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "custom",
                              attrs: { "label-width": "0" }
                            },
                            [
                              _c("cargo-input", {
                                attrs: {
                                  no: "32",
                                  "auto-uppercase": true,
                                  type: "textarea",
                                  rows: 12
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.SecondNotifyParty"),
                                      _vm.form.alsoNotify,
                                      function(val) {
                                        _vm.form.alsoNotify = val
                                      },
                                      true
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.alsoNotify,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "alsoNotify", $$v)
                                  },
                                  expression: "form.alsoNotify"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ]
          ),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "33", type: "primary" },
                  on: { click: _vm.handleSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "34" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "198px" },
            attrs: { disabled: _vm.readonly },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("hs-code-search-dialog", {
        attrs: {
          visible: _vm.hsCodeSearchDialog.visible,
          title: _vm.hsCodeSearchDialog.title
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.hsCodeSearchDialog, "visible", $event)
          },
          callback: _vm.hsCodeSearchDialog.successCallback
        }
      }),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.form },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }